module.exports = "/images/implementation_toolkit.svg?d7aed47773d8459d73423279f0bc21c2";